import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import AdminSideNav from "../../../adminComponents/sidenav";
import AdminHeader from "../../../adminComponents/header";
import Table from "./Table";

const Did = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          ml: { xs: "0px", md: "200px" },
        }}
      >
        <AdminSideNav />
        <Box
          sx={{
            display: {
              xs: "none",
              md: "initial",
            },
          }}
        >
          <AdminHeader title={"DIDs Management"} />
        </Box>
        <Box>
          <Table />
        </Box>
      </Box>
    </Box>
  );
};

export default Did;
